export default __webpack_public_path__ + "assets/images/itemlist-bg-3231f741.jpg";